import dJSON from 'dirty-json';

import {
  animate,
  onScroll,
} from 'animejs';

const moduleSelector = '.timeline';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.timeline-wrapper').insertAdjacentHTML('beforeend', /* html */ `
          <div class="timeline-item">
            <div class="point"></div>
            <div class="content-wrapper">
              <h3 class="title with-line">${item.title}</h3>
              <p class="details">${item.text}</p>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * AnimeJS
 */
(() => {
  const timelineItems = document.querySelectorAll('.timeline-item');
  if (timelineItems) {
    timelineItems.forEach((item) => {
      animate(item, {
        autoplay: onScroll({
          enter: 'center 0%',
          leave: 'center 100%',
          sync: 0.5,
          onEnter: () => item.classList.add('active'),
          onLeave: () => item.classList.remove('active'),
        }),
      });
    });
  }
})();
